import { BillingFrequency, BillingStatus, Currency } from '@css-xp/graphtypes/src/generated-types-new';

export const getPricingPlanFilterOptionsForNativeCatalog = (
  isMultiCurrencyEnabled: boolean,
  fetchOnlyAnnualData = false
) => {
  const pricingPlans: Record<any, any>[] = [
    {
      key: 'status',
      value: BillingStatus.ACTIVE,
    },
  ];
  if (fetchOnlyAnnualData) {
    pricingPlans.push({
      key: 'billingFrequency',
      value: BillingFrequency.ANNUAL,
    });
  } else {
    pricingPlans.push({
      key: 'billingFrequency',
      value: BillingFrequency.MONTHLY,
    });
  }
  if (!isMultiCurrencyEnabled) {
    pricingPlans.push({
      key: 'currency',
      value: Currency.USD,
    });
  }
  return pricingPlans;
};
